import React, { useEffect, useState } from "react";
import { Badge, Form, Modal, Spinner } from "react-bootstrap";
import { studyTreatmentManagementServices } from "../../../../APIServices/CTMS/studyTreatmentManagementServices";
import { useParams } from "react-router";

const UpdateQueryCustomValueModal = ({
  Show,
  Hide,
  setCustomValue,
  customValue,
  setCustomType,
  customType,
  setValueId,
  valueId,
  setQuery,
  queryId,
  setQueryId,
  query,
}) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [treatmentRows, setTreatmentRows] = useState([]);
    const { studyId } = useParams()
  const updateQueryCustomVValue = (customType, customValue, valueId) => {
    setButtonLoader(true);
    const updatedQuery = query?.map(item => {
      if (item.id === queryId) {
        return {
          ...item,
          valueType: customType,
          value: customValue || "",
          valueId: valueId || "",
        };
      }
      return item;
    });
    setQuery(updatedQuery);
    setCustomValue("");
    setValueId("");
    setQueryId("")
    Hide()
    setButtonLoader(false);
  };

  const getStudyTreatmentRowData = async (e) => {
    let data = await studyTreatmentManagementServices.getStudyTreatmentRowData(
      "active",
      studyId,
    );
    setTreatmentRows(data?.data || []);
  };

  useEffect(() => {
    if (customType === "treatment") {
      getStudyTreatmentRowData()
    }
  }, [customType]);
  return (
    <>
      <Modal show={Show} onHide={Hide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            Replace Custom Value
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Value Type{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => { setCustomType(e.target.value); setCustomValue(e.target.value === "subjectScreeningDate" ? "SCREENINGDATE" : e.target.value === "missing" ? "MISSING" : "") }}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={customType === ""} value="">Select Type</option>
              <option selected={customType === "text"} value="text">Text</option>
              <option selected={customType === "number"} value="number">Number</option>
              <option selected={customType === "date"} value="date">Date</option>
              <option selected={customType === "time"} value="time">Time</option>
              <option selected={customType === "treatment"} value="treatment">
                Treatment
              </option>
              <option selected={customType === "missing"} value="missing">
                Missing
              </option>
              <option selected={customType === "subjectScreeningDate"} value="subjectScreeningDate">Subject Screening Date</option>
            </Form.Select>
          </Form.Group>
          {customType === "treatment" ?
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Treatment{" "}
                <abbr title="required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Select
                value={customValue}
                onChange={(e) => { setCustomValue(e.target.value); setValueId(e.target[e.target.selectedIndex].title) }}
                style={{ fontSize: 12 }}
                className="br3"
              >
                <option value="">
                  Select Treatment
                </option>
                {treatmentRows?.map((item, index) => (
                  <option key={index} title={item?.treatmentId} value={item?.row?.TREATMENTID}>
                    {item?.row?.TREATMENTID}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            :
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Custom Value{" "}
                <abbr title="required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                onChange={(e) => setCustomValue(e.target.value)}
                value={customValue}
                className="br3"
                placeholder="Custom Value"
                disabled={customType === "subjectScreeningDate" || customType === "missing"}
                type={customType}
              />
            </Form.Group>
          }
        </Modal.Body>
        <Modal.Footer className="p-1 px-3 bg-light">
          <button
            className="updateProfile"
            style={{ fontSize: 12 }}
            disabled={!customValue || !customType}
            onClick={() => updateQueryCustomVValue(customType, customValue, valueId)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Replacing...
              </div>
            ) : (
              "Replace"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateQueryCustomValueModal;
